import { useEffect, useRef } from 'react';

import { sendDriverActivityHeartbeat } from '../services/apis/dispense/routeAudit';

const HEARTBEAT_INTERVAL_MS = 180000;
const ACTIVITY_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'visibilitychange', 'focus'];

const useDriverLiveActivity = ({ pharmacyId, route = null, enabled = true }) => {
	const lastHeartbeatSentAtRef = useRef(0);
	const heartbeatInFlightRef = useRef(false);

	useEffect(() => {
		if (!enabled || !pharmacyId) {
			return undefined;
		}

		const sendHeartbeat = (force = false) => {
			if (document.visibilityState === 'hidden' || heartbeatInFlightRef.current) {
				return;
			}

			const now = Date.now();
			if (!force && now - lastHeartbeatSentAtRef.current < HEARTBEAT_INTERVAL_MS) {
				return;
			}

			heartbeatInFlightRef.current = true;
			lastHeartbeatSentAtRef.current = now;
			sendDriverActivityHeartbeat({
				pharmacyId,
				route: `${route ?? ''}`.trim() || undefined,
			})
				.catch(() => {})
				.finally(() => {
					heartbeatInFlightRef.current = false;
				});
		};

		const triggerActivityPing = () => {
			sendHeartbeat();
		};
		const intervalId = window.setInterval(() => {
			sendHeartbeat();
		}, HEARTBEAT_INTERVAL_MS);

		ACTIVITY_EVENTS.forEach((eventName) => {
			window.addEventListener(eventName, triggerActivityPing, { passive: true });
		});

		sendHeartbeat(true);

		return () => {
			window.clearInterval(intervalId);
			ACTIVITY_EVENTS.forEach((eventName) => {
				window.removeEventListener(eventName, triggerActivityPing);
			});
		};
	}, [enabled, pharmacyId, route]);
};

export default useDriverLiveActivity;
